let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kz89n")).then(() => parcelRequire('b43Uy'));